import { render, staticRenderFns } from "./markDialog.vue?vue&type=template&id=e5599b8e&scoped=true"
import script from "./markDialog.vue?vue&type=script&lang=js"
export * from "./markDialog.vue?vue&type=script&lang=js"
import style0 from "./markDialog.vue?vue&type=style&index=0&id=e5599b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5599b8e",
  null
  
)

export default component.exports